<template>
  <div class="banner">
    <div class="content-center">
      <div class="banner-body">
        <div class="banner-title">解决方案大模型</div>
        <div class="banner-subtitle">根据客户所在行业和体量，从不同角度为客户提供专属的数智化项目管理咨询、助力精准规划，打造专属方案</div>
        <div class="primary-btn" @click="navigateToChat">立即体验</div>
        <!-- <div class="banner-input-wrapper">
          <input class="banner-input" v-model="input" placeholder="在线输入您的需求，为您提供专业的业务规划解决方案" />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data () {
    return {
      // input: ''
    }
  },
  computed: {
    ...mapGetters(['isLoggIn'])
  },
  methods: {
    ...mapActions(['setLoginPopup', 'setLoginCallback']),
    /**
     * 跳转ai对话界面
     */
    navigateToChat() {
      if (this.isLoggIn) this.$router.push('/scheme/chat');
      else {
        this.setLoginPopup(true);
        this.setLoginCallback(() => {
          this.$router.push('/scheme/chat');
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.banner {
  height: 460px;
  background-image: url('@/assets/img/scheme/Banner/background.png');
  background-size: cover;
  background-position: center;

  .content-center {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .banner-body {
      .banner-title {
        font-family: @font-bold;
        font-size: 32px;
        line-height: 65px;
        letter-spacing: 2px;
      }
      .banner-subtitle {
        margin-top: 13px;
        color: @info-color;
        width: 530px;
        line-height: 32px;
      }
      // .banner-input-wrapper {
      //   display: flex;
      //   align-items: center;
      //   margin-top: 53px;
      //   width: 624px;
      //   height: 54px;
      //   background: rgba(255,255,255,0.3);
      //   border-radius: 4px 4px 4px 4px;
      //   border: 1px solid #FF8200;
      //   padding-right: 3px;
      // }
      // .banner-input {
      //   flex: 1;
      //   height: 100%;
      //   padding: 0 20px;
      //   background: transparent;
      //   border: none;
      //   outline: none;
      //   font-size: 14px;
      //   color: #1D2129;

      //   &::placeholder {
      //     color: #666;
      //   }
      // }
      .primary-btn {
        margin-top: 53px;
        width: 164px;
      }
    }
  }
}
</style>
